import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { appActions } from 'src/store/actions';
import CONSTANTS from 'src/store/constants';

import { Col, Container, Div, Row, Text } from '@pinpoint/design-kit';

import { Page } from 'src/containers';

function DataEnrichmentDownload() {
  const dispatch = useDispatch();
  const presignedUrlStatus = useSelector(({ app: { presignedUrlStatus: stat } }) => stat);
  const presignedUrl = useSelector(({ app: { presignedUrl: preUrl } }) => preUrl);
  const location = useLocation();
  const [bucket, setBucket] = useState(null);
  const [key, setKey] = useState(null);

  const uuidPathPrefixRegex = useMemo(
    () => /^client_upload_det\/[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}\//,
    []
  );

  useEffect(() => {
    if (location && location.search) {
      const query = new URLSearchParams(location.search);
      setBucket(query.get('bucket'));
      setKey(query.get('key'));
    }
  }, [location]);

  useEffect(() => {
    if (!['', null, undefined].includes(key) && !['', null, undefined].includes(bucket)) {
      const strippedKey = key.replace(uuidPathPrefixRegex, '');
      dispatch(appActions.getPresignedUrl(bucket, strippedKey));
    }
  }, [dispatch, bucket, key, uuidPathPrefixRegex]);

  useEffect(() => {
    if (presignedUrlStatus === CONSTANTS.API.SUCCEEDED) {
      window.open(presignedUrl, '_blank');
    } else if (presignedUrlStatus === CONSTANTS.API.FAILED) {
      const message = 'There is an error when downloading. Please try again or contact support';
      dispatch(appActions.enqueueNotification(message, { autoClose: false }));
    }
  }, [presignedUrlStatus, presignedUrl, dispatch]);

  return (
    <Container>
      <Row d="flex" m={{ x: '-0.25rem', t: '5rem', b: '1.25rem' }}>
        <Col size="12" gutterWidth="1.25rem">
          <Div
            bg="white"
            rounded="md"
            p={{ x: '1.5rem', y: '1.25rem' }}
            w="100%"
            textColor="shade33"
            d="flex"
            justify="space-between"
            align="flex-start"
          >
            <Div d="flex" flexDir="column" justify="space-between" align="flex-start">
              <Text textSize="title" textColor="tabSelected" m={{ y: '0.5rem' }}>
                Download
              </Text>
              <Text textSize="subheader" m={{ y: '0.5rem' }} textColor="tabSelected">
                Your download should begin shortly. Please wait...
              </Text>
            </Div>
          </Div>
        </Col>
      </Row>
    </Container>
  );
}

export default Page(DataEnrichmentDownload);
